import style from './Styles/index.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons'
import { FormattedMessage } from 'react-intl'
import { actualSchemaVersion } from '../../versions'
import { faXmark } from '@fortawesome/free-solid-svg-icons/faXmark'
import React from 'react'

interface Props {
    schemaVersion: string
    onSchemaVersionMismatch: () => void
}

export const ConfigVersionMismatchPopup = ({ schemaVersion, onSchemaVersionMismatch }: Props) => {
    return (
        <div
            className={`d-flex bg-white p-1 z-1 ${style.vMismatch}`}
        >
            <FontAwesomeIcon
                className="p-2"
                color={'#4B6687'}
                icon={faExclamationCircle}
            />
            <span className="p-1">
                <FormattedMessage
                    tagName="span"
                    id={'schema.versionNotMatchMessage'}
                    values={{
                        configurationSchemaVersion: String(schemaVersion),
                        actualSchemaVersion,
                    }}
                />{' '}
                &nbsp; &#x263a;
            </span>
            <button className="btn-clean p-1 pl-2 ml-auto mr-2 mb-auto">
                <FontAwesomeIcon
                    icon={faXmark}
                    onClick={onSchemaVersionMismatch}
                />
            </button>
        </div>
    )
}